// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: languages.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "languages";

export interface Language {
  code: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
}

export interface Languages {
  defaultLanguageCode: string;
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
  additionalLanguages: Language[];
}

export interface LanguagesUpdateDefaultLanguage {
  languageCode: string;
}

export interface LanguagesAddLanguage {
  code: string;
}

export interface LanguagesDeleteLanguage {
  code: string;
}

function createBaseLanguage(): Language {
  return { code: "", createdAt: undefined, createdBy: "", updatedAt: undefined, updatedBy: "" };
}

export const Language: MessageFns<Language> = {
  encode(message: Language, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(18).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(26).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(42).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Language {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Language {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: Language): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<Language>): Language {
    return Language.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Language>): Language {
    const message = createBaseLanguage();
    message.code = object.code ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseLanguages(): Languages {
  return { defaultLanguageCode: "", updatedBy: undefined, updatedAt: undefined, additionalLanguages: [] };
}

export const Languages: MessageFns<Languages> = {
  encode(message: Languages, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.defaultLanguageCode !== "") {
      writer.uint32(10).string(message.defaultLanguageCode);
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(18).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    for (const v of message.additionalLanguages) {
      Language.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Languages {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguages();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.defaultLanguageCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.additionalLanguages.push(Language.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Languages {
    return {
      defaultLanguageCode: isSet(object.defaultLanguageCode)
        ? globalThis.String(object.defaultLanguageCode)
        : isSet(object.default_language_code)
        ? globalThis.String(object.default_language_code)
        : "",
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      additionalLanguages: globalThis.Array.isArray(object?.additionalLanguages)
        ? object.additionalLanguages.map((e: any) => Language.fromJSON(e))
        : globalThis.Array.isArray(object?.additional_languages)
        ? object.additional_languages.map((e: any) => Language.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Languages): unknown {
    const obj: any = {};
    if (message.defaultLanguageCode !== "") {
      obj.defaultLanguageCode = message.defaultLanguageCode;
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.additionalLanguages?.length) {
      obj.additionalLanguages = message.additionalLanguages.map((e) => Language.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<Languages>): Languages {
    return Languages.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Languages>): Languages {
    const message = createBaseLanguages();
    message.defaultLanguageCode = object.defaultLanguageCode ?? "";
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.additionalLanguages = object.additionalLanguages?.map((e) => Language.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLanguagesUpdateDefaultLanguage(): LanguagesUpdateDefaultLanguage {
  return { languageCode: "" };
}

export const LanguagesUpdateDefaultLanguage: MessageFns<LanguagesUpdateDefaultLanguage> = {
  encode(message: LanguagesUpdateDefaultLanguage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.languageCode !== "") {
      writer.uint32(10).string(message.languageCode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguagesUpdateDefaultLanguage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguagesUpdateDefaultLanguage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.languageCode = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguagesUpdateDefaultLanguage {
    return {
      languageCode: isSet(object.languageCode)
        ? globalThis.String(object.languageCode)
        : isSet(object.language_code)
        ? globalThis.String(object.language_code)
        : "",
    };
  },

  toJSON(message: LanguagesUpdateDefaultLanguage): unknown {
    const obj: any = {};
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguagesUpdateDefaultLanguage>): LanguagesUpdateDefaultLanguage {
    return LanguagesUpdateDefaultLanguage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguagesUpdateDefaultLanguage>): LanguagesUpdateDefaultLanguage {
    const message = createBaseLanguagesUpdateDefaultLanguage();
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseLanguagesAddLanguage(): LanguagesAddLanguage {
  return { code: "" };
}

export const LanguagesAddLanguage: MessageFns<LanguagesAddLanguage> = {
  encode(message: LanguagesAddLanguage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguagesAddLanguage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguagesAddLanguage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguagesAddLanguage {
    return { code: isSet(object.code) ? globalThis.String(object.code) : "" };
  },

  toJSON(message: LanguagesAddLanguage): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguagesAddLanguage>): LanguagesAddLanguage {
    return LanguagesAddLanguage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguagesAddLanguage>): LanguagesAddLanguage {
    const message = createBaseLanguagesAddLanguage();
    message.code = object.code ?? "";
    return message;
  },
};

function createBaseLanguagesDeleteLanguage(): LanguagesDeleteLanguage {
  return { code: "" };
}

export const LanguagesDeleteLanguage: MessageFns<LanguagesDeleteLanguage> = {
  encode(message: LanguagesDeleteLanguage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LanguagesDeleteLanguage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLanguagesDeleteLanguage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LanguagesDeleteLanguage {
    return { code: isSet(object.code) ? globalThis.String(object.code) : "" };
  },

  toJSON(message: LanguagesDeleteLanguage): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    return obj;
  },

  create(base?: DeepPartial<LanguagesDeleteLanguage>): LanguagesDeleteLanguage {
    return LanguagesDeleteLanguage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<LanguagesDeleteLanguage>): LanguagesDeleteLanguage {
    const message = createBaseLanguagesDeleteLanguage();
    message.code = object.code ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
